import { LanguageSelector, simbolSvg, ToggleTheme } from '@hub/shared'
import MaintenancePage from '@pages/maintenance/maintenance.page'
import NotFoundPage from '@pages/not-found/not-found.page'
import GeneralErrorPage from '@src/pages/general-error/general-error.page'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router'
import { Route, Routes } from 'react-router-dom'
import './error.layout.scoped.scss'
import './error.layout.scss'

export default (props: any) => {
  const { i18n } = useTranslation()

  return (
    <div className="error-layout">
      <span className="bg" style={{ backgroundImage: `url(${simbolSvg})` }} />
      <main className="container box">
        <Routes>
          <Route path={'/not-found'} element={<NotFoundPage {...props} />} />
          <Route path={'/maintenance'} element={<MaintenancePage {...props} />} />
          <Route path={'/general-error'} element={<GeneralErrorPage {...props} />} />
          <Route path={'/'} element={<Navigate to="/error/not-found" />} />
          <Route element={<Navigate to="/error/not-found" />} />
        </Routes>
        <div className="text-center mt-5 display-flex align-items-center justify-content-center">
          <ToggleTheme />
        </div>
        <div className="text-center mt-3 display-flex align-items-center justify-content-center">
          <LanguageSelector lang={i18n.language as any} />
        </div>
      </main>
    </div>
  )
}
